/**
 * @generated SignedSource<<4654bfdfd3e20081cf96674156c0485e>>
 * @relayHash b167c3924c240111eb2c04f5138be112
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 488e4e7ceb05d5d63726635de6bb578e2d4b52a4643ab9ca4393d1579b8d07f0

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type menuNavigationAppsSidebarFiltersGlobalScopeQuery$variables = {
  cloudId: string;
};
export type menuNavigationAppsSidebarFiltersGlobalScopeQuery$data = {
  readonly jira: {
    readonly " $fragmentSpreads": FragmentRefs<"starredFiltersList_navigationAppsSidebarCommon" | "systemFilters_navigationAppsSidebarFilters_SystemFiltersSection">;
  };
};
export type menuNavigationAppsSidebarFiltersGlobalScopeQuery = {
  response: menuNavigationAppsSidebarFiltersGlobalScopeQuery$data;
  variables: menuNavigationAppsSidebarFiltersGlobalScopeQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider": isAddLimitToNav3StarredFilterSidebarEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider: {
    readonly get: () => boolean;
  };
});

import isAddLimitToNav3StarredFilterSidebarEnabled_provider from '@atlassian/jira-relay-provider/src/is-add-limit-to-nav3-starred-filter-sidebar-enabled.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = [
  (v1/*: any*/)
],
v3 = {
  "kind": "ScalarField",
  "name": "filterId"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "isFavourite"
},
v6 = {
  "kind": "ScalarField",
  "name": "jql"
},
v7 = {
  "kind": "ScalarField",
  "name": "name"
},
v8 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isEditable"
    }
  ],
  "type": "JiraCustomFilter"
},
v9 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/)
    ],
    "kind": "Fragment",
    "name": "menuNavigationAppsSidebarFiltersGlobalScopeQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": (v2/*: any*/),
              "kind": "FragmentSpread",
              "name": "starredFiltersList_navigationAppsSidebarCommon"
            },
            {
              "args": (v2/*: any*/),
              "kind": "FragmentSpread",
              "name": "systemFilters_navigationAppsSidebarFilters_SystemFiltersSection"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "menuNavigationAppsSidebarFiltersGlobalScopeQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              (v1/*: any*/),
              {
                "kind": "Literal",
                "name": "isFavourite",
                "value": false
              }
            ],
            "concreteType": "JiraSystemFilterConnection",
            "kind": "LinkedField",
            "name": "systemFilters",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraSystemFilterEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraSystemFilter",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/)
                        ],
                        "type": "JiraFilter",
                        "abstractKey": "__isJiraFilter"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "favouriteFilters",
                "args": [
                  (v1/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "sort": {
                        "order": "DESC"
                      },
                      "type": "FILTER"
                    }
                  },
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 15
                  }
                ],
                "concreteType": "JiraFavouriteConnection",
                "kind": "LinkedField",
                "name": "favourites",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraFavouriteEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v3/*: any*/),
                              (v5/*: any*/),
                              (v6/*: any*/),
                              (v7/*: any*/),
                              (v8/*: any*/)
                            ],
                            "type": "JiraFilter",
                            "abstractKey": "__isJiraFilter"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v4/*: any*/)
                            ],
                            "type": "Node",
                            "abstractKey": "__isNode"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": "favouriteFiltersOld",
                "args": (v2/*: any*/),
                "concreteType": "JiraFilterConnection",
                "kind": "LinkedField",
                "name": "favouriteFilters",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraFilterEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v3/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isJiraFilter"
                          },
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v4/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "488e4e7ceb05d5d63726635de6bb578e2d4b52a4643ab9ca4393d1579b8d07f0",
    "metadata": {},
    "name": "menuNavigationAppsSidebarFiltersGlobalScopeQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider": isAddLimitToNav3StarredFilterSidebarEnabled_provider
    }
  }
};
})();

(node as any).hash = "b5467e25277d67ce676aa25dd3a16377";

export default node;
